import { render, staticRenderFns } from "./relreceitasdesp.vue?vue&type=template&id=71212839"
import script from "./relreceitasdesp.vue?vue&type=script&lang=js"
export * from "./relreceitasdesp.vue?vue&type=script&lang=js"
import style0 from "./relreceitasdesp.vue?vue&type=style&index=0&id=71212839&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports